import "../../../../../../vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import { createTextVNode as t } from "../../../../../../@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
function f(e, ...n) {
  return typeof e == "function" ? e(...n) : typeof e == "string" ? t(e) : typeof e == "number" ? t(String(e)) : null;
}
export {
  f as render
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/_utils/vue/render.js
// module id = 127
// module chunks = 67